<template>
  <div id="app">
    <el-container>
      <el-main style="padding: 0px" >
        <router-view @checkLogin="checkLogin"/>
      </el-main>
    </el-container>
    <Login ref="login" @loginSuccess="loginSuccess"></Login>
  </div>
</template>

<script>

import Login from './LoginModal';

export default {
  name: 'App',
  data() {
    return {
      login: false,
    }
  },
  created: function () {
  },
  components: {
    Login,
  },
  methods: {

    loginSuccess: function () {
      this.login = true;
      this.getUserInfo();
    },
    checkLogin: function () {
      let token = localStorage.getItem("token");
      if (!token) {
        this.$refs.login.init()
        return false;
      } else {
        return true;
      }
    }
  }
}
</script>

<style>
</style>
